import QuizFeedAttemptReportData from './QuizFeedAttemptReportData';

export default QuizFeedAttemptReportData;
